import { DrupalClient } from "./client"

const getRedis = () => {
  if (typeof window !== "undefined") return null
  // dynamic require so webpack never bundles it client-side
  return require("../cache").redis
}

export const redisCache = {
  async set(key, value) {
    const redis = getRedis()
    if (!redis?.set) return
    return await redis.set(key, value)
  },

  async get(key) {
    const redis = getRedis()
    if (!redis?.get) return Promise.resolve(false)
    return await redis.get(key)
  },
}

export const drupal = new DrupalClient({
  cache: redisCache,
  debug: "DRUPAL_CLIENT_DEBUG" in process.env || "development" === process.env.NODE_ENV,
  nextDrupalApi: process.env.NEXT_PUBLIC_DRUPAL_BASE_URL,
})
